<template>
  <div>
    <!-- 撤销处方对话框 -->
    <el-dialog
      title="处方撤销提醒"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      show-close
      append-to-body
      custom-class="revocation-dialog"
      @close="handleClose"
    >
      <div class="revocation-dialog-content">
        <div class="revocation-warning-text">仅支持对未结算取药的处方进行撤销。</div>
        <div class="revocation-info-text">
          发起处方撤销操作后，系统将同时在医院信息系统、卫健监管平台和医保电子处方平台进行处方撤销。
        </div>
        <div class="revocation-info-text">撤销后，处方信息仍可见，但状态为已撤销，处方笺标记已作废。</div>
        <div class="revocation-subtitle">请选择撤销原因:</div>
        <el-checkbox-group v-model="revocationReason" @change="handleReasonChange">
          <el-checkbox label="处方信息填写错误">处方信息填写错误</el-checkbox>
          <el-checkbox label="患者不需要买药了">患者不需要买药了</el-checkbox>
          <el-checkbox label="其他">其他</el-checkbox>
        </el-checkbox-group>
        <el-input
          v-if="revocationReason.includes('其他')"
          v-model="revocationOtherReason"
          type="textarea"
          :rows="3"
          placeholder="请描述撤销原因(25字以内)"
          :maxlength="25"
          style="margin-top: 12px"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">暂不撤销</el-button>
        <el-button type="primary" @click="handleConfirm" :disabled="revocationReason.length === 0">
          未结算 确定撤销
        </el-button>
      </span>
    </el-dialog>
    <!-- 撤销成功提醒弹窗 -->
    <el-dialog
      :visible.sync="successDialogVisible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      show-close
      append-to-body
      custom-class="revocation-success-dialog"
    >
      <div class="revocation-success-content">
        <div class="success-text">处方撤销已受理,请在处方详情页查看撤销结果</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="successDialogVisible = false">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Fetch from '@/api';

export default {
  name: 'RevocationDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    prescriptionId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      revocationReason: [], // 撤销原因（数组）
      revocationOtherReason: '', // 其他原因描述
      successDialogVisible: false // 撤销成功提醒弹窗
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.revocationReason = [];
        this.revocationOtherReason = '';
      }
    },
    dialogVisible(val) {
      if (!val) {
        this.$emit('update:visible', false);
      }
    }
  },
  methods: {
    handleReasonChange() {
      if (!this.revocationReason.includes('其他')) {
        this.revocationOtherReason = '';
      }
    },
    handleCancel() {
      this.dialogVisible = false;
      this.revocationReason = [];
      this.revocationOtherReason = '';
      this.$emit('cancel');
    },
    handleClose() {
      this.revocationReason = [];
      this.revocationOtherReason = '';
      this.$emit('cancel');
    },
    handleConfirm() {
      if (this.revocationReason.length === 0) {
        this.$message.warning('请选择撤销原因');
        return;
      }
      if (this.revocationReason.includes('其他') && !this.revocationOtherReason.trim()) {
        this.$message.warning('请描述撤销原因');
        return;
      }
      // 将选中的原因用顿号拼接
      let reasonArray = [...this.revocationReason];
      // 如果包含"其他"，替换为其他原因描述
      const otherIndex = reasonArray.indexOf('其他');
      if (otherIndex !== -1) {
        reasonArray[otherIndex] = this.revocationOtherReason.trim();
      }
      const reason = reasonArray.join('、');
      Fetch.prescriptionRevocation({
        prescriptionId: this.prescriptionId,
        reason: reason
      })
        .then(() => {
          this.dialogVisible = false;
          this.revocationReason = [];
          this.revocationOtherReason = '';
          // 显示撤销成功提醒弹窗
          this.successDialogVisible = true;
          this.$emit('success');
        })
        .catch(error => {
          this.$message.error(error.message || '撤销处方失败');
        });
    }
  }
};
</script>

<style lang="scss" scoped>
// 撤销处方对话框样式
/deep/ .revocation-dialog {
  .el-dialog__header {
    padding: 20px 20px 12px;
    text-align: left;
    .el-dialog__title {
      text-align: left;
    }
  }
  .el-dialog__body {
    padding: 0 20px 20px;
    text-align: left;
  }
}
.revocation-dialog-content {
  .revocation-warning-text {
    color: #e0514c;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 12px;
  }
  .revocation-info-text {
    font-size: 14px;
    color: #595959;
    line-height: 22px;
    margin-bottom: 12px;
  }
  .revocation-subtitle {
    font-size: 14px;
    color: #242424;
    font-weight: 500;
    margin-top: 24px;
    margin-bottom: 16px;
    text-align: left;
  }
  .el-checkbox-group {
    display: flex;
    flex-direction: column;
    .el-checkbox {
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
/deep/ .revocation-dialog {
  .el-dialog__footer {
    text-align: right;
    .dialog-footer {
      .el-button {
        margin-left: 12px;
        &:first-child {
          margin-left: 0;
        }
        // 暂不撤销按钮：白底黑字灰框
        &:not(.el-button--primary) {
          background-color: #ffffff;
          color: #242424;
          border-color: #d9d9d9;
          &:hover {
            background-color: #f5f5f5;
            border-color: #d9d9d9;
            color: #242424;
          }
        }
        // 确定撤销按钮：蓝底白字
        &.el-button--primary {
          background-color: #1e8dff;
          border-color: #1e8dff;
          color: #ffffff;
          margin-right: 12px;
          &:hover {
            background-color: #4da3ff;
            border-color: #4da3ff;
          }
          &:disabled {
            background-color: #c0c4cc;
            border-color: #c0c4cc;
            color: #ffffff;
          }
        }
      }
    }
  }
}
// 撤销成功提醒弹窗样式
/deep/ .revocation-success-dialog {
  .el-dialog {
    background: #ffffff;
    border: 1px solid #e0e0e0;
  }
  .el-dialog__header {
    padding: 0;
    border-bottom: none;
  }
  .el-dialog__headerbtn {
    top: 12px;
    right: 12px;
  }
  .el-dialog__body {
    padding: 40px 20px 20px;
    text-align: center;
  }
  .el-dialog__footer {
    padding: 20px;
    text-align: right;
    .dialog-footer {
      .el-button {
        background-color: #ffffff;
        color: #242424;
        border-color: #d9d9d9;
        &:hover {
          background-color: #f5f5f5;
          border-color: #d9d9d9;
          color: #242424;
        }
      }
    }
  }
}
.revocation-success-content {
  .success-text {
    font-size: 16px;
    color: #242424;
    margin-bottom: 12px;
    font-weight: 500;
  }
  .success-hint {
    font-size: 14px;
    color: #595959;
    line-height: 22px;
  }
}
</style>
